<template>
    <div class="dynamic-panels">
        <div class="dyna-header">
            <div class="username">{{ firstName }}</div>
            <div class="date">Appointment: {{ apptDate }}, {{apptTime}}<span v-show="apptLocation"> at {{apptLocation}}</span></div>
        </div>
        <div class="dyna-contents">
            <component v-bind:is="currentPanelComponent" />
        </div>
        <div class="dyna-footer">
            <div class="panel-controls" v-show="currentPanel != 'Intro'">
                <div class="panel-controls-left">
                    <button v-on:click="donePanel">Done</button>
                </div>
                <div class="panel-controls-middle" v-show="currentPanel != 'Conclusion'">
                    <button v-on:click="skipPanel" v-show="currentPanel != 'Magic' && currentPanel != 'Social' && currentPanel != 'Importance' && currentPanel != 'Conclusion'">Skip</button>
                </div>
                <div class="panel-controls-right">
                    <button v-on:click="helpMe">Help</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Intro_panel from '@/components/panels/Intro_panel.vue'
    import Challenges_panel from '@/components/panels/Challenges_panel.vue'
    import Body_panel from '@/components/panels/Body_panel.vue'
    import Magic_panel from '@/components/panels/Magic_panel.vue'
    import Color_panel from '@/components/panels/Color_panel.vue'
    import Social_panel from '@/components/panels/Social_panel.vue'
    import Importance_panel from '@/components/panels/Importance_panel.vue'
    import Changes_panel from '@/components/panels/Changes_panel.vue'
    import Conclusion_panel from '@/components/panels/Conclusion_panel.vue'
    import panelState from '@/stores/panelState.js'
    import scenes from '@/stores/scenes.js'
    import response from '@/stores/response.js'

    export default {
        name: 'DynamicPanels',
        created: function() {
            var self = this;
            self.$root.$on('change-panel', function(panel) {
                self.switchToPanel(panel);
            });
            self.$root.$on('next-panel', function(panel) {
                self.nextPanel();
            });
            self.$root.$on('done-panel', function() {
                self.donePanel();
            });
            self.$root.$on('hide-convo', function() {
                self.hideElement('.convo-history-side');
            });
        },
        data: function() {
            return {
                currentPanel: 'Intro',
                panelState : panelState,
                scenes : scenes,
                response: response,
                panelSkipped: false
            };
        },
        computed: {
            currentPanelComponent: function() {
                return this.currentPanel + '_panel';
            }
        },
        props: [
            "firstName",
            "apptDate",
            "apptTime",
            "apptLocation"
        ],
        methods: {
            switchToPanel: function(panel) {
                this.hideElement('.convo-history-side');
                this.currentPanel = panel;
                this.$root.$emit('panelChange', panel);
            },
            nextPanel: function() {
                this.hideElement('.convo-history-side');
                this.panelState.curPanel++;
                if (this.panelState.panels[this.panelState.curPanel] == "Body"){
                    if (this.$children[0].$children[0].selectedValues.indexOf('Pain') == -1){
                        this.panelState.curPanel++; // if pain is not selected skip body selection panels
                    }
                }
                this.switchToPanel(this.panelState.panels[this.panelState.curPanel]);
                this.$root.$emit('nlp-response', {answerText: this.scenes[this.currentPanel + '_panel']});
            },
            donePanel: function() {
                CodeBaby.jQuery('.codebaby-stt-button:visible').hide();
                CodeBaby.jQuery('.no-nlp').hide();
                console.log('donePanel');
                if( this.currentPanel == "Challenges" && this.$children[0].$children[0].selectedValues.length <= 0) {
                    //this.curPanel++; // if pain is not selected skip body selection panels
                    this.skipPanel();
                }else{

                    //if( this.currentPanel == "Challenges" && this.$children[0].$children[0].selectedValues.indexOf('Pain') == -1) this.curPanel++; // if pain is not selected skip body selection panels
                    switch (this.currentPanel) {
                        case "Social":
                        case "Importance":
                        case "Magic":
                            this.saveData(CodeBaby.jQuery('#no-nlp-field').val());
                            CodeBaby.jQuery('#no-nlp-field').val('');
                            break;
                        default:
                            CodeBaby.jQuery('.no-nlp:visible').hide();
                    }
                    this.hideElement('.convo-history-side');
                    CodeBaby.fire(this.currentPanel + '_Done');
                    this.$root.$emit('nlp-response', {answerText: this.scenes[this.currentPanel + '_Done']});
                }
            },
            skipPanel: function() {
                CodeBaby.jQuery('.codebaby-stt-button:visible').hide();
                CodeBaby.jQuery('.no-nlp').hide();
                if(this.currentPanel == "Challenges") CodeBaby.storage.set("challengesSkipped", true);
                CodeBaby.fire(this.currentPanel + '_Skip');
                this.$root.$emit('nlp-response', {answerText: this.scenes[this.currentPanel + '_Skip']});
                this.hideElement('.convo-history-side');

            },
            helpMe: function() {
                CodeBaby.fire(this.currentPanel + '_Help');
                this.$root.$emit('nlp-response', {answerText: this.scenes[this.currentPanel + '_Help']});
                this.hideElement('.convo-history-side');
            },
            saveData: function(answer) {
                this.hideElement('.convo-history-side');
                this.response[(this.panelState.curPanel)].answer = answer;
            },
            hideElement: function(selector) {
                CodeBaby.jQuery(selector).hide();
            }
        },
        components: {
            Intro_panel,
            Challenges_panel,
            Conclusion_panel,
            Body_panel,
            Magic_panel,
            Color_panel,
            Social_panel,
            Importance_panel,
            Changes_panel
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.dynamic-panels
    display: flex
    flex-direction: column
    height: 100%
    width: 100%
    overflow: hidden
    border-radius: 2em
    .dyna-header
        padding: 0.75em 2em
        text-align: left
        line-height: 1.25em
        font-weight: bold
        color: #fff
        min-height: 3em
    .dyna-contents
        flex: 1
        color: #333
        align-items: center
        height: 450px
        width: 450px
        padding: 0 75px
    .dyna-footer
        position: absolute
        bottom: 0
        right: 53%
        text-align: right
        padding: 1.3em 3.5em
        div
            display: inline-block
        button
            border-radius: 2em
            text-align: center
            font-weight: 600
            min-width: 60px
            position: relative
            box-sizing: border-box
            color: #777
            height: 1.7em
            display: inline-block
            margin-right: 8px
            background-size: 100% 100%
            background-repeat: no-repeat
            -webkit-font-smoothing: antialiased
            -moz-osx-font-smoothing: grayscale
            background-color: #AAA
            border: none
            &:hover
                color: #fff
</style>
